<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">MAP OF THE BAR HARBOR HISTORIC BUILDINGS AND MONUMENTS TRAIL</p>
<p class="hang">1. Ells Plaque (Bar Harbor Municipal Pier, One Town Pier)</p>
<p class="hang">2. Galyn’s Restaurant (17 Main Street)</p>
<p class="hang">3. Sherman’s Book Store (56 Main Street)</p>
<p class="hang">4. Morrison Building (62 Main Street)</p>
<p class="hang">5. First National Bank (102 Main Street)</p>
<p class="hang">6. Bar Harbor Hemporium (116 Main Street)</p>
<p class="hang">7. Roberts Monument (Village Green, Main Street)</p>
<p class="hang">8. Bandstand (Village Green, Main and Mount Desert Street)</p>
<p class="hang">9. Ash Graves, Mount Desert Street Cemetery (41 Mount Desert Street)</p>
<p class="hang">10. St. Saviour’s Episcopal Church and Rectory (41 Mount Desert Street) 11. Ledgelawn Inn (66 Mount Desert Street)</p>
<p class="hang">12. Stone Throw Cottage Inn and Mira Monte Inn (67 and 69 Mount Desert Street)</p>
<p class="hang">13. Jane Parker House (48 Holland Avenue)</p>
<p class="hang">14. Walter Bird House (10 Holland Avenue)</p>
<p class="hang">15. Alonzo Ash House (6 Summer Street)</p>
<p class="hang">16. George Edwin Kirk American Legion Post (70 Cottage Street)</p>
<p class="hang">17. Star Theatre Building (44 Cottage Street)</p>
<p class="hang">18. Whale Watch Building (55 West Street)</p>
<p class="hang">19. Bar Harbor Club (111 West Street)</p>
<p class="hang">20. La Rochelle, Bar Harbor Historical Society (127 West Street)</p>
<p class="hang">21. DeGregoire Green and Plaque (corner Eden and West Streets)</p>
<p class="hang">22. Sonny Cough Plaque (Atlantic Eyrie Lodge) (6 Norman Road)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Maps.vue?303abc55